export const SESSIONS_PER_PAGE = 6;

export enum SecuritySection {
  ChangePassword = 'change-password',
  TwoFactorAuthentication = 'two-factor-authentication',
}

export const getDeviceName = (userAgent: string): string[] | null => {
  const regex = /\(([^)]+)\)/;
  const match = userAgent.match(regex);

  if (!match) return null;
  return match[1].split(';');
};

export enum TwoFactorStep {
  First = 'first',
  Second = 'second',
  Third = 'third',
}

export enum SessionStatus {
  Current = 'current',
  Active = 'active',
  Closed = 'closed',
}

export const COPIED_MESSAGE_DELAY = 6;
